import { Pipe, PipeTransform } from '@angular/core';
import { Audit340BClaimStatusNum } from '@module-claims/enums/enum-claim-status';

const STATUS_340B_MAP = new Map<Audit340BClaimStatusNum, string>([
  [Audit340BClaimStatusNum.IS_340B, 'Yes'],
  [Audit340BClaimStatusNum.NOT_340B, 'No'],
  [Audit340BClaimStatusNum.NOT_EVALUATED, 'Not Evaluated']
]);

@Pipe({
  name: 'claim340bStatusYesNo',
  standalone: false
})
export class Claim340bStatusYesNoPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null) {
      return '';
    }

    return STATUS_340B_MAP.get(value) ?? '';
  }
}
